import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Outlet, useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Breadcrumb, Button, Form, Input, Select, Space, Spin} from "antd";
import BackButton from "../../../tech/back_button";
import DB_OperationTypes from "../../../../database/dictionary/operation_types";
import DB_PatternActivity from "../../../../database/dictionary/pattern-activity";

const OperationType = () => {
    const {operation_type_id} = useParams()
    const {token, setToken} = useContext(Context)
    const {get, update} = DB_OperationTypes(token)
    const {getActivePatternActivities} = DB_PatternActivity(token);
    const {t} = useTranslation()
    const {errorConnect, noPermission} = ModalWindow()
    const params = useLocation().state
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const [wait, setWait] = useState(false)
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams({})
    const path = location.state == null ? null : (location.state.path == null ? null : location.state.path)
    const controller = new AbortController()
    const [patternActivity, setPatternActivity] = useState([])


    useEffect(() => {
        if (operation_type_id !== 'new'){
            if (wait) {
                controller.abort()
            }
            setWait(true)

            searchParams.set('id', operation_type_id)

            get(controller, searchParams)
                .then(res => {

                    res.data.pattern_activities.map(p => {
                        if (p.status === 0) {
                            setPatternActivity(current => [...current, p])
                        }
                    })

                    form.setFieldsValue({
                        name: res.data.name,
                        pattern_activity_id: res.data.pattern_activities.map(p => p.id),
                    })


                    setWait(false);
                })
                .catch((e) => {
                    if (e.status === 403) {
                        setToken(null)
                    } else if (e.request.status === 401) {
                        noPermission()
                    } else {
                        errorConnect()
                    }
                })
                .finally(() => {
                    setWait(false)
                })
        } else {
            setWait(false);
        }
    }, [])

    useEffect(() => {
        getActivePatternActivities()
            .then(res => {
                setPatternActivity(res.data)
            })
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });
    }, [])

    const onFinish = async (values) => {
        setWait(true);


        const formData = new FormData();
        formData.append('name', values["name"])
        formData.append('pattern_activities', values['pattern_activity_id'])

        if (operation_type_id !== 'new') {
            formData.append('id', operation_type_id)
        }

        update(formData)
            .then(res => {
                if (res.status === 200) {
                    setWait(false)
                    // navigate(path ? `/finance/pay-forms?${path}` : "/finance/pay-forms", {replace: true})
                    navigate(-1)
                } else {
                    errorConnect()
                }
            })
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else if (e.request.status === 401) {
                    noPermission()
                } else {
                    errorConnect()
                }
            })
            .finally(() => {
                setWait(false)
            })
    }


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb style={{margin: '15pt 0'}}>
                        <Breadcrumb.Item>
                            <span
                                className={'ant-page-header-heading-title'}
                                style={{paddingLeft:'24px'}}
                            >
                                {t('operation_type')}
                            </span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton/>
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}
                                key='2'>{operation_type_id === 'new' ? t('create') : t('update')}</Button>
                    </Space>
                </Space>


                <Form form={form}
                      style={{marginTop: '15pt'}}
                      labelCol={{
                          span: 8
                      }}
                      wrapperCol={{
                          span: 10
                      }}
                      layout={"vertical"}
                      onFinish={onFinish}
                      autoComplete="off"
                      id={"form"}
                >
                    <Form.Item style={{marginBottom: '10pt'}}
                               name="name"
                               label={t('name')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_input', {input: t('name').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Input showCount maxLength={50}/>
                    </Form.Item>

                    <Form.Item
                        name="pattern_activity_id"
                        label={t('pattern_activity')}
                    >
                        <Select mode={"multiple"} allowClear>
                            {patternActivity.map(pa => {
                                    if (pa.status !== 0) {
                                        return <Select.Option key={pa.id} value={pa.id}>{t(pa.name)}</Select.Option>
                                    }
                                }
                            )}
                        </Select>
                    </Form.Item>
                </Form>
            </div>
            <Outlet/>
        </Spin>
    )

}

export default OperationType